<div class="fade-in editor-container" *ngIf="!selectedFrameForAssets">
  <div class="content-section">
    <div class="section-header">
      <div class="header-flex">
        <button class="secondary-btn" (click)="close()">← Back to Layout</button>
        <h2 class="header-title">Frame Groups for Theme: {{ themeId }}</h2>
        <span class="meta-badge" [class.global-badge]="isGlobal" [class.device-badge]="!isGlobal">
          {{ isGlobal ? 'Global' : 'Device' }}
        </span>

        <!-- Manage Backgrounds Button -->
        <button *ngIf="!version" class="secondary-btn btn-xs btn-manage-bg" (click)="openBgModal()">
          🖼️ Manage Backgrounds
        </button>
        <span *ngIf="isLoadingBackground" class="spinner-inline loading-bg-spinner"></span>
      </div>
      <button class="primary-btn" *ngIf="!version && tileType !== 'Signature' && tileType !== 'FeaturedFrame'" (click)="openAddModal()">+ Add Frame Group</button>
    </div>

    <div class="loading-container" *ngIf="isLoading">
      <div class="spinner-small loading-frames-spinner"></div>
      <p class="loading-frames-text">Loading frame groups...</p>
    </div>

    <div class="table-container frames-table-container" *ngIf="!isLoading">
      <table class="ledger-table">
        <thead>
          <tr>
            <th *ngIf="!version" style="width: 40px" class="text-center">↕️</th>
            <th>ID</th>
            <th>Frame Group Name</th>

            <th>Description</th>
            <th class="text-center col-actions">Actions</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr *ngFor="let frame of frames" cdkDrag [cdkDragDisabled]="!!version" class="draggable-row">
            <td *ngIf="!version" class="text-center drag-handle" cdkDragHandle style="cursor: grab; opacity: 0.5;">⣿</td>
            <td class="font-mono text-highlight">{{ frame.id }}</td>
            <td class="company-name">{{ frame.name }}</td>

            <td class="text-secondary">{{ frame.description }}</td>
            <td class="text-center">
              <button class="icon-action-btn mr" (click)="openAssetsManager(frame.id)" title="Manage Assets">🖼️</button>
              <button class="icon-action-btn mr" *ngIf="!version && tileType !== 'FeaturedFrame'" (click)="editFrame(frame)" title="Edit">✏️</button>
              <button class="icon-action-btn danger" *ngIf="!version && tileType !== 'Signature' && tileType !== 'FeaturedFrame'" (click)="deleteFrame(frame.id)" title="Delete">🗑️</button>
            </td>
          </tr>
          <tr *ngIf="frames.length === 0">
            <td [attr.colspan]="version ? 4 : 5" class="empty-state-large">
              No frame groups added for this theme yet.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Modal Form for Add/Edit -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content fade-in" [class.saving-mode]="isSaving">
    <div class="modal-header-flex">
      <h3 class="modal-title no-margin-bottom">
        {{ editingId ? 'Edit Frame Group' : 'Add New Frame Group' }}
      </h3>
    </div>
    
    <div class="form-grid">
      <div class="form-group full-width">
        <label>Frame Group ID *</label>
        <input [(ngModel)]="newFrame.id" [disabled]="isSaving || !!editingId" (input)="onIdInput($event)" placeholder="e.g. frame_01" class="form-input font-mono">
      </div>
      <div class="form-group full-width">
        <label>Frame Group Name *</label>
        <input [(ngModel)]="newFrame.name" [disabled]="isSaving" placeholder="e.g. Summer Special" class="form-input">
      </div>

      <div class="form-group full-width">
        <label>Frame Group Description</label>
        <textarea [(ngModel)]="newFrame.description" [disabled]="isSaving" placeholder="e.g. Blue background with suns" class="form-input" rows="3"></textarea>
      </div>
    </div>

    <div class="modal-actions mt-4">
      <button class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
      <button class="primary-btn" (click)="saveFrame()" [disabled]="isSaving">
        <span *ngIf="isSaving" class="spinner-small"></span>
        <span>{{ editingId ? 'Update Frame Group' : 'Add Frame Group' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Background Management Modal -->
<div class="modal-overlay" *ngIf="isBgModalOpen">
  <div class="modal-content fade-in bg-modal-content">
    <div class="bg-modal-header">
      <h3 class="modal-title bg-modal-title">🖼️ Manage Frame Group Backgrounds</h3>
      <button class="icon-action-btn" (click)="closeBgModal()">✕</button>
    </div>

    <!-- Bottom Layer Section -->
    <div class="bg-layer-section bg-layer-bottom">
      <h4 class="bg-layer-title">Bottom Layer</h4>
      <p class="bg-layer-desc">This image renders <strong>behind</strong> the frame group selection buttons.</p>
      
      <div class="bg-preview-flex">
        <div *ngIf="bottomBgPreview" class="bg-preview-box">
          <img [src]="bottomBgPreview.url" alt="Bottom BG" class="bg-preview-img">
          <span class="bg-preview-name">{{ bottomBgPreview.name }}</span>
          <button class="icon-action-btn danger btn-xs bg-preview-remove" (click)="removeBackground('bottom')" [disabled]="isUploadingBackground">🗑️</button>
        </div>
        <div *ngIf="!bottomBgPreview" class="bg-preview-empty">No bottom layer uploaded.</div>
        
        <div>
          <label for="bottomBgUpload" class="secondary-btn bg-upload-label" [class.disabled]="isUploadingBackground">
            <span>{{ bottomBgPreview ? 'Replace' : 'Upload' }}</span>
          </label>
          <input id="bottomBgUpload" type="file" accept=".png" (change)="uploadBackground($event, 'bottom')" [disabled]="isUploadingBackground" class="d-none">
        </div>
      </div>
    </div>

    <!-- Top Layer Section -->
    <div class="bg-layer-section">
      <h4 class="bg-layer-title">Top Layer</h4>
      <p class="bg-layer-desc">This image renders <strong>above</strong> the frame group selection buttons (as a foreground overlay).</p>
      
      <div class="bg-preview-flex">
        <div *ngIf="topBgPreview" class="bg-preview-box">
          <img [src]="topBgPreview.url" alt="Top BG" class="bg-preview-img">
          <span class="bg-preview-name">{{ topBgPreview.name }}</span>
          <button class="icon-action-btn danger btn-xs bg-preview-remove" (click)="removeBackground('top')" [disabled]="isUploadingBackground">🗑️</button>
        </div>
        <div *ngIf="!topBgPreview" class="bg-preview-empty">No top layer uploaded.</div>
        
        <div>
          <label for="topBgUpload" class="secondary-btn bg-upload-label" [class.disabled]="isUploadingBackground">
            <span>{{ topBgPreview ? 'Replace' : 'Upload' }}</span>
          </label>
          <input id="topBgUpload" type="file" accept=".png" (change)="uploadBackground($event, 'top')" [disabled]="isUploadingBackground" class="d-none">
        </div>
      </div>
    </div>

    <div *ngIf="isUploadingBackground" class="bg-uploading-indicator">
      <span class="spinner-inline"></span> Uploading background...
    </div>

    <div class="modal-actions mt-4">
      <button class="primary-btn" (click)="closeBgModal()">Done</button>
    </div>
  </div>
</div>

<!-- Frame Assets Manager -->
<app-frame-assets-manager 
  *ngIf="selectedFrameForAssets" 
  [themeId]="themeId" 
  [frameId]="selectedFrameForAssets" 
  [isGlobal]="isGlobal"
  [deviceId]="deviceId"
  [version]="version"
  [tileType]="tileType"
  (closeManager)="closeAssetsManager()">
</app-frame-assets-manager>
